import { Skeleton } from 'components/ui/skeleton';
import { ProductCard } from '../ProductCard';
import { useQuery } from '@apollo/client';
import {
  AmazonProduct,
  Product,
  ShopifyProduct,
} from '../../../../app/graphql/generated/cart/graphql';
import { GET_PRODUCTS_BY_IDS } from '../../../../app/graphql';
import { marketplaceStringToEnum } from '../../../../utils/marketplaceSelector';
import { OrderByIdQuery } from 'app/graphql/generated/admin/graphql';

type Props = {
  products: OrderByIdQuery['orderById']['products'];
  marketplace: 'amazon' | 'shopify';
};

export function ProductsList({ products, marketplace }: Props) {
  const { loading, data } = useQuery(GET_PRODUCTS_BY_IDS, {
    variables: {
      input: products.map((product) => {
        return {
          id: product.productId,
          marketplace: marketplaceStringToEnum(marketplace),
        };
      }),
    },
  });

  const productMap: Record<string, Product | undefined> = {};
  data?.productsByIds?.products?.forEach(
    (product: Product | ShopifyProduct | AmazonProduct, index: number) => {
      productMap[product?.id ?? products[index].productId] = product ?? products[index];
    },
  );
  return (
    <div className="flex w-max space-x-4 p-4">
      {products.map((product) => {
        if (loading) {
          return (
            <div className="flex flex-col space-y-3">
              <Skeleton className="aspect-[3/4] w-[250px]" />
              <Skeleton className="h-4 w-24" />
              <Skeleton className="h-4 w-[250px]" />
            </div>
          );
        } else {
          return (
            <ProductCard
              className="w-[250px]"
              key={product.productId}
              product={productMap[product.productId]}
              variantId={'variantId' in product ? (product.variantId as string) : undefined}
              marketplace={marketplace}
            />
          );
        }
      })}
    </div>
  );
}
